enum ViewMode {
  View,
  Edit
}

export default ViewMode;
